import type { RouteRecordRaw } from "vue-router";

export const routes: RouteRecordRaw[] = [
  {
    path: "/",
    component: () => import("@/modules/www/layouts/MarketingLayout.vue"),
    meta: { public: true, theme: "www" },
    children: [
      { path: "", name: "home", component: () => import("@/modules/www/pages/HomePage.vue") },
      {
        path: "product",
        name: "product",
        component: () => import("@/modules/www/pages/ProductPage.vue"),
      },
      {
        path: "enterprise",
        name: "enterprise",
        component: () => import("@/modules/www/pages/EnterprisePage.vue"),
      },
      {
        path: "pricing",
        name: "pricing",
        component: () => import("@/modules/www/pages/PricingPage.vue"),
      },
      {
        path: "auth",
        name: "auth",
        component: () => import("@/modules/www/pages/AuthPage.vue"),
      },
      {
        path: "payment-success",
        name: "payment-success",
        component: () => import("@/modules/www/pages/PaymentSuccess.vue"),
      },
      {
        path: "404",
        name: "not-found",
        component: () => import("@/modules/www/pages/NotFound.vue"),
      },
    ],
  },
  // 旧地址兼容：/login、/register、/company/login 统一跳转到 /auth（保留 query，如 redirect 参数）
  {
    path: "/login",
    redirect: (to) => ({ path: "/auth", query: to.query }),
  },
  {
    path: "/register",
    redirect: { path: "/auth", query: { mode: "register" } },
  },
  {
    path: "/company/login",
    redirect: (to) => ({ path: "/auth", query: to.query }),
  },
  {
    path: "/payment-result",
    alias: "/vip-payment-result",
    name: "PaymentResult",
    component: () => import("@/shared/pages/PaymentResultPage.vue"),
    meta: { public: true },
  },
  {
    path: "/company",
    component: () => import("@/modules/company/layouts/CompanyLayout.vue"),
    meta: { requiredAccountType: "company" },
    children: [
      {
        path: "",
        name: "company-dashboard",
        component: () => import("@/modules/company/pages/CompanyDashboard.vue"),
      },
      {
        path: "employees",
        name: "company-employees",
        component: () => import("@/modules/company/pages/CompanyEmployees.vue"),
      },
      {
        path: "billing",
        name: "company-billing",
        component: () => import("@/modules/company/pages/CompanyBilling.vue"),
      },
      {
        path: "categories",
        name: "company-categories",
        component: () => import("@/modules/company/pages/CompanyCategories.vue"),
      },
      {
        path: "profile",
        name: "company-profile",
        component: () => import("@/modules/company/pages/CompanyProfile.vue"),
      },
      {
        path: "task",
        name: "task",
        component: () => import("@/modules/company/pages/CompanyTasks.vue"),
        meta: { title: "任务" },
      },
      {
        path: "consumption-dashboard",
        name: "company-consumption-dashboard",
        component: () => import("@/modules/company/pages/CompanyConsumptionDashboard.vue"),
        meta: { title: "消耗总览" },
      },
      {
        path: ":pathMatch(.*)*",
        name: "company-not-found",
        component: () => import("@/shared/pages/NotFoundInline.vue"),
      },
    ],
  },
  {
    path: "/employee",
    component: () => import("@/modules/employee/layouts/UserLayout.vue"),
    meta: { requiredAccountType: "employee" },
    children: [
      {
        path: "",
        name: "employee-workbench",
        component: () => import("@/modules/employee/pages/WorkbenchPage.vue"),
      },
      {
        path: "profile",
        name: "employee-profile",
        component: () => import("@/modules/employee/pages/EmployeeDashboard.vue"),
        meta: { title: "账号信息" },
      },
      {
        path: "tickets",
        name: "employee-tickets",
        component: () => import("@/modules/employee/pages/TicketsPage.vue"),
        meta: { title: "我的工单" },
      },
      {
        path: ":pathMatch(.*)*",
        name: "employee-not-found",
        component: () => import("@/shared/pages/NotFoundInline.vue"),
      },
    ],
  },
  { path: "/:pathMatch(.*)*", name: "catch-all", redirect: "/404" },
];
